let IslandBookManager = require("./IslandBookManager");
let IslandsManager = require("clover/scene/component/IslandsSystem/IslandsManager");
let ShareUtil = require("clover/utils/ShareUtil")

let IslandFullStarPanel = xClass("IslandFullStarPanel", BasePanel, () => {
    return cc.CSLoader.createNode("cocos/islandBook_share_panel.csb");
});

var ResPack = [
    "packed/islandStarFull.pack",
    "font/zzgftongxin_40_greenstroke.fnt"
]

IslandFullStarPanel.asyncCreate = function (onCloseCallback, fail, cancel) {
    function onSuccess() {
        let panel = IslandFullStarPanel.create(onCloseCallback);
        panel.popup(true,null, null, null, true);
    }
    preloadWithLoading(ResPack, onSuccess, fail, cancel);
}

IslandFullStarPanel.prototype.ctor = function (onCloseCallback) {
    let self = this
    self.onCloseCallback = onCloseCallback;
    self.init();
}

IslandFullStarPanel.prototype.onEnter = function () {
    let self = this;
    BasePanel.prototype.onEnter.call(self)
    let parent = self.getParent();
    if (parent) {
        let parent2 = parent.getParent();
        parent2.setLocalZOrder(110000);
    }
}
IslandFullStarPanel.prototype.init = function () {
    let self = this;
    BasePanel.prototype.init.call(self);
    self.setScale(self.getReferenceScale());

    DCAssist.dc4User101("island_star", "encourage_show", {
        "levelid": IslandBookManager.getInstance().playingislandId,
        "current_stage": IslandBookManager.getInstance().playingLevelId})

    let shareGroupName = "islands_fullstars";
    let data = TextsManager.getInstance().getRandomTexts(shareGroupName);
    DCAssist.dc4ShareShow(shareGroupName, data.textId);
    

    self.initLabels()
    self.initButton()
}

IslandFullStarPanel.prototype.initButton = function ()
{
    let self = this
    //  分享按钮
    self.btnShare = UIGroupButton.create(self.getChildByName("button"));
    self.addChild(self.btnShare);
    self.btnShare.on(UIButtonEvent.Click, handler(self, () => {self.onShareBtnClick()}));
    PushBounceIdleBubbleAnim.create(self.btnShare);


    self.btnClose = UIButton.create(self.getChildByName("close_blue"));
    self.btnClose.on(UIButtonEvent.Click, handler(self, self.onClose));

    self.checkbox = null;
    self.isSelected = true;
    if (getCurrentPlatformAllowShare()) {

        // 点击区
        let checkBoxWrapper = findNode(this, "toggle/checkBox")
        UIButton.create(checkBoxWrapper);
        self.getChildByName("toggle").addChild(checkBoxWrapper);
        checkBoxWrapper.on(UIButtonEvent.Click, handler(self, self.onCheckBoxClicked));

        let checkbox = findNode(this, "toggle/checkBox/checkmark")
        self.checkbox = checkbox;
        self.isSelected = false;
        self.onCheckBoxClicked();
    } else {
        self.isSelected = false;
        self.getChildByName("toggle").removeFromParent(true);
    }
}

/**
 * 复选框点击回调
 */
IslandFullStarPanel.prototype.onCheckBoxClicked = function () {
    let self = this;

    if (self.isSelected) {
        self.isSelected = false;
        
    } else {
        self.isSelected = true;
    }
    self.checkbox.setVisible(self.isSelected);

    if (!self.isSelected)
    {
        DCAssist.dc4User101("island_star", "share_cancel")
    }
}


IslandFullStarPanel.prototype.initLabels = function () {
    let self = this
    this.getChildByName("title").setString(getText("islands.window.title"))

    findNode(this, "island_bg/txt").visible = false
    findNode(this, "island_bg/level").visible = false

    let island = UserManager.getInstance().getIslandConfigById(IslandBookManager.getInstance().playingislandId)
    
    findNode(this, "island_bg/title").setString(island.name)
    findNode(this, "island_bg/title").setLocalZOrder(11)
    findNode(this, "island_bg/title_decorate_red").setLocalZOrder(10)
    findNode(this, "island_bg/Full_Stars").setLocalZOrder(10)

    findNode(this, "island_bg/Full_Stars").setScale(2.5, 2.5)
    const csbPath = "cocos/islandBook_Full_Stars.csb"
    let action = cc.CSLoader.createTimeline(csbPath);
    action.gotoFrameAndPlay(0, true);
    findNode(this, "island_bg/Full_Stars").runAction(action);
    

    //  海岛节点
    let imgPath = IslandsManager.getInstance().getIslandRes(island).island;
    preloadWithLoading(imgPath, () => {
        let islandSprite = cc.Sprite.create(imgPath);
        self.getChildByName("island_bg").addChild(islandSprite);
        islandSprite.setAnchorPoint(0.5, 0.5);
        let scale = findNode(self, "island_bg").width / islandSprite.width 
        islandSprite.setScale(scale, scale)
        islandSprite.setPosition(self.getChildByName("island_bg").width / 2, self.getChildByName("island_bg").height / 2);
    }, null, null, false);

    let islandUnlockConfig = MetaManager.getInstance().getIslandUnlockConfig();
    findNode(this, "toggle/tips").setString(getText("island_unlock_share_text") +" " + islandUnlockConfig.island_unlock_share_reward)
    findNode(this, "button/txt").setString(getText("islands.window.button"))
}

/**
 * 关闭回调
 */
IslandFullStarPanel.prototype.onClose = function () {
    var self = this
    if (self.onCloseCallback) {
        self.onCloseCallback()
    }
    BasePanel.prototype.onClose.call(self)
    self.isBusy = false
}

IslandFullStarPanel.prototype.cleanup = function () {
    unloadResList(ResPack)
    BasePanel.prototype.cleanup.call(this)
}


/**
 * 分享按钮点击回调
 */
IslandFullStarPanel.prototype.onShareBtnClick = function () {
    let self = this

    if (self.isBusy) {
        return;
    }

    self.isBusy = true;

    if (self.isSelected) {
        DCAssist.userTrack("island", "upgrade");
        let unlockConfig = MetaManager.getIslandUnlockConfig();

        var success = function(){
            self.isBusy = false;
           // self.onClose();
        }
        var fail = function(){
            Toast.make(getText("islands.window.prompt"), 1, () => {
                self.isBusy = false;
            });
        }

        self.shareTextId = ShareUtil.shareIslandFull(success, fail, fail);
    } else {
        self.isBusy = false;
        self.onClose();
    }
}

module.exports = IslandFullStarPanel